<div class="list-group">
  @for (versions of sortedApplications(); track versions; let index = $index) {
    <ml-mdm-apple-application-list-item-ui #item
                                           class="list-group-item list-group-item-action"
                                           [class.active]="selectedIndex === index"
                                           [applicationVersions]="versions"
                                           [hideVersionSelector]="hideVersionSelector()"
                                           (click)="select(index)"
                                           (selectedApplicationChange)="itemSelectionChanged(index, $event)"></ml-mdm-apple-application-list-item-ui>
  }
</div>